/**
 * Map Default Configuration
 * Default values for new maps and levels
 */

import { GRID_CONSTANTS } from '../../shared/constants/GridConstants';

export const MAP_DEFAULTS = {
  /** Default map dimensions in tiles */
  widthTiles: 60,
  heightTiles: 30,
  tileSize: GRID_CONSTANTS.TILE_SIZE,

  /** Default physics */
  gravity: 1000,

  /** Default background */
  backgroundColor: '#1a1a2e', // Dark blue-purple

  /** Default spawn point (in tiles) - positioned just above ground */
  spawnPoint: {
    x: 10,
    y: 13  // 13 * 32 = 416px, ground is at 500px, so ~84px above ground
  },

  /** Editor grid dimensions (larger than default map for editor workspace) */
  editorGrid: {
    widthTiles: 100,
    heightTiles: 50
  },

  /** Ground platform defaults */
  ground: {
    // y: 800 was too low (player spawns falling), y: 500 is better
    y: 500,
    height: 32, // 1 tile
    color: '#4A5568', // Slate gray
    type: 'normal' as const
  }
};

/** Calculate spawn point in world coordinates */
export const getDefaultSpawnWorld = () => ({
  x: MAP_DEFAULTS.spawnPoint.x * MAP_DEFAULTS.tileSize,
  y: MAP_DEFAULTS.spawnPoint.y * MAP_DEFAULTS.tileSize
});

/** Calculate ground position in tile coordinates */
export const getGroundTileY = () => {
  return Math.floor(MAP_DEFAULTS.ground.y / MAP_DEFAULTS.tileSize);
};
